import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const ChaveAcessorios = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Chaves";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.chaveAcessorios})` }}>
        <div className="servico-hero-overlay">
          <h1>Chaves</h1>
          {/* <p>Para quem procura por chaves e acessórios</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Chaves e Acessórios */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.copiaChaves} alt="" /></div>
            <h3>Tipos</h3>
            <p>Chaves residenciais, comerciais e automotivas.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.cadeados} alt="" /></div>
            <h3>Cadeados</h3>
            <p>Modelos com chave ou segredo.</p>
          </div>

          <div>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('chaves')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('chaves')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default ChaveAcessorios;